module.exports = __webpack_public_path__ + "img/icon-competence-2.bb9e9847.svg";